import React from 'react';
import { Card, Tag, Alert, Space, Divider, Button } from 'antd';
import { buildAPIURL } from '../../config/apiConfig';

const PermissionDebug: React.FC = () => {
  const userInfo = JSON.parse(localStorage.getItem('quanly_truonghoc_user') || '{}');
  const permissions = userInfo?.permissions || JSON.parse(localStorage.getItem('permissions') || '[]');
  const token = localStorage.getItem('quanly_truonghoc_token');

  console.log('🐛 Debug - UserInfo:', userInfo);
  console.log('🐛 Debug - Permissions:', permissions);
  console.log('🐛 Debug - Token:', token);

  // Fix role key checking - try multiple possible keys
  const roleKey = (userInfo?.RoleKey || userInfo?.roleKey || '').toLowerCase();
  const isAdmin = roleKey === 'admin';

  // Debug localStorage content
  const debugLocalStorage = () => {
    console.log('=== ALL localStorage content ===');
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key) {
        const value = localStorage.getItem(key);
        console.log(`${key}:`, value);
      }
    }
  };

  const handleTestAPI = async () => {
    try {
  const response = await fetch(buildAPIURL('/permissions/modules'), {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      
      console.log('🧪 API Test Response Status:', response.status);
      const data = await response.json();
      console.log('🧪 API Test Response Data:', data);
    } catch (error) {
      console.error('🧪 API Test Error:', error);
    }
  };

  const handleLogin = () => {
    window.location.href = '/login';
  };

  const handleClearStorage = () => {
    // Clear all authentication data
    localStorage.removeItem('quanly_truonghoc_token');
    localStorage.removeItem('quanly_truonghoc_user');
    localStorage.removeItem('userInfo');
    localStorage.removeItem('permissions');
    
    // Also clear any other possible token keys
    localStorage.removeItem('token');
    localStorage.removeItem('access_token');
    localStorage.removeItem('authToken');
    
    alert('Đã xóa tất cả dữ liệu authentication. Trang sẽ được refresh.');
    window.location.reload();
  };

  const isValidJWT = (token: string) => {
    if (!token) return false;
    const parts = token.split('.');
    return parts.length === 3;
  };

  const tokenValid = isValidJWT(token || '');

  return (
    <div style={{ padding: 24 }}>
      <Card title="🐛 Permission Debug Info">
        <Space direction="vertical" style={{ width: '100%' }}>
          
          {/* Authentication Status */}
          <div>
            <strong>🔐 Authentication Status:</strong>
            <div>Token exists: <Tag color={token ? 'green' : 'red'}>{token ? 'YES' : 'NO'}</Tag></div>
            <div>Token valid format: <Tag color={tokenValid ? 'green' : 'red'}>{tokenValid ? 'YES' : 'NO'}</Tag></div>
            {token && (
              <div style={{ marginTop: 8, fontSize: '12px', wordBreak: 'break-all' }}>
                Token: {token.substring(0, 50)}...
                <br />
                Token length: {token.length}
                <br />
                Token parts: {token.split('.').length} (should be 3 for JWT)
              </div>
            )}
            {!token && (
              <Alert 
                message="No authentication token found" 
                description="User needs to login first"
                type="error"
                showIcon
                action={
                  <Button size="small" danger onClick={handleLogin}>
                    Go to Login
                  </Button>
                }
              />
            )}
            {token && !tokenValid && (
              <Alert 
                message="Invalid JWT Token Format" 
                description="Token is not in valid JWT format. This may be causing the 'jwt malformed' error."
                type="error"
                showIcon
                action={
                  <Button size="small" danger onClick={handleClearStorage}>
                    Clear & Refresh
                  </Button>
                }
              />
            )}
          </div>

          <Divider />

          <div>
            <strong>👤 Current User:</strong>
            <div>Username: {userInfo?.Username || 'N/A'}</div>
            <div>FullName: {userInfo?.FullName || 'N/A'}</div>
            <div>Role: {userInfo?.RoleName || 'N/A'}</div>
            <div>RoleKey: {roleKey || 'N/A'}</div>
            <div>Is Admin: <Tag color={isAdmin ? 'green' : 'red'}>{isAdmin ? 'YES' : 'NO'}</Tag></div>
            <div style={{ marginTop: 8, fontSize: '12px', color: '#666' }}>
              Raw UserInfo: <pre style={{ fontSize: '10px' }}>{JSON.stringify(userInfo, null, 2)}</pre>
            </div>
          </div>

          <Divider />

          <div>
            <strong>🔑 Permissions ({permissions.length} total):</strong>
            {permissions.length === 0 ? (
              <Alert 
                message="No permissions found" 
                description="User has no permissions or they are not loaded properly"
                type="warning"
                showIcon
              />
            ) : (
              <div style={{ marginTop: 8 }}>
                {permissions.map((perm: any, index: number) => {
                  const moduleKey = (perm.Module || perm.ModuleKey || perm.module || perm.modulekey || '').toLowerCase();
                  const canView = perm.CanView || perm.canView || perm.View || perm.view;
                  const canAll = perm.CanAll || perm.canAll || perm.All || perm.all;
                  
                  return (
                    <div key={index} style={{ marginBottom: 8 }}>
                      <Tag color={canView || canAll ? 'green' : 'red'}>
                        {moduleKey || 'Unknown Module'}
                      </Tag>
                      <span style={{ marginLeft: 8 }}>
                        View: {canView ? '✅' : '❌'}, 
                        All: {canAll ? '✅' : '❌'}
                      </span>
                    </div>
                  );
                })}
              </div>
            )}
          </div>

          <Divider />

          <div>
            <strong>🎯 Expected Module Keys for Permissions Menu:</strong>
            <div style={{ marginTop: 8 }}>
              <Tag>role_permissions_module</Tag>
              <Tag>permission_management_module</Tag>
              <Tag>user_permission_module</Tag>
            </div>
          </div>

          <Divider />

          <div>
            <strong>🧪 Actions:</strong>
            <div style={{ marginTop: 8 }}>
              <Space>
                <Button onClick={handleTestAPI} type="primary" disabled={!token}>
                  Test Permissions API
                </Button>
                <Button onClick={debugLocalStorage}>
                  Debug localStorage
                </Button>
                <Button onClick={handleClearStorage} danger>
                  Clear All Auth Data
                </Button>
                <Button onClick={handleLogin}>
                  Go to Login
                </Button>
              </Space>
              <div style={{ marginTop: 8, fontSize: '12px', color: '#666' }}>
                Check console for API test results
              </div>
            </div>
          </div>

          <Divider />

          <div>
            <strong>🔍 Common Issues & Solutions:</strong>
            <ol>
              <li><strong>JWT Malformed Error:</strong> Token format is invalid - Clear storage and login again</li>
              <li><strong>403 Forbidden:</strong> Token expired or user has no permissions</li>
              <li><strong>401 Unauthorized:</strong> No token or invalid token</li>
              <li><strong>Mixed Backend Systems:</strong> Token from JavaScript backend won't work with TypeScript backend</li>
            </ol>
          </div>

          {!token && (
            <Alert 
              message="Authentication Required" 
              description="Please login first to access the permission management system"
              type="error"
              showIcon
            />
          )}

          {token && tokenValid && isAdmin && (
            <Alert 
              message="Admin User Detected" 
              description="As admin, you should see all menus regardless of permissions"
              type="info"
              showIcon
            />
          )}

          {token && !tokenValid && (
            <Alert 
              message="Token Format Error" 
              description="Current token is causing 'jwt malformed' errors. Clear storage and login again."
              type="error"
              showIcon
            />
          )}

          {token && tokenValid && !isAdmin && permissions.length === 0 && (
            <Alert 
              message="No Permissions Found" 
              description="Non-admin user with no permissions will not see permission menus"
              type="error"
              showIcon
            />
          )}
        </Space>
      </Card>
    </div>
  );
};

export default PermissionDebug; 